export default "__VITE_ASSET__710a8d1e__"